import { render, staticRenderFns } from "./InmueblesList.vue?vue&type=template&id=a741904c&"
import script from "./InmueblesList.vue?vue&type=script&lang=js&"
export * from "./InmueblesList.vue?vue&type=script&lang=js&"
import style0 from "./InmueblesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports